import { TicketQuestionnaireViewComponent } from './components/ticket-questionnaire-view/ticket-questionnaire-view.component';
import { NzButtonType } from 'ng-zorro-antd/button';
import {
	Component,
	OnDestroy,
	OnInit,
	TemplateRef,
	ViewChild,
} from '@angular/core';
import {
	TicketSectionDto,
	DynamicFormDto,
	DynamicFormElementDto,
	TicketDetailDto,
	TicketDto,
	TicketElementDto,
	TicketStepDto,
	TicketButtonDto,
	DynamicPayloadDto_PropertyValueSimple,
	ButtonTypeEnum,
	TicketUploadPayload,
	TicketModeEnum,
	AbstractDto,
	TicketQuestionnaireDto,
	WorkflowStepSectionElementDto,
	TicketHistoryDto,
	TicketHistoryCapturedFieldDto,
} from '../../../service/dto';
import { HttpWorkflowService } from '../../../service/http-workflow.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpTicketService } from '../../../service/http-ticket.service';
import { Subscription } from 'rxjs';
import {
	FormControl,
	FormGroup,
	FormBuilder,
	FormArray,
	Validators,
} from '@angular/forms';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import {
	ComposeNotificationComponent,
	NotificationDto,
} from '../../../components/compose-notification/compose-notification.component';
import { FormControlWrapper } from '../../../components/dynamic-form/dynamic-form-abstract';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { InvalidFormDrawerComponent } from '../../workflow/workflow-form/components/invalid-form-drawer/invalid-form-drawer.component';
import { TicketCommunicationModalComponent } from './components/ticket-communication-modal/ticket-communication-modal.component';
import { TicketAdditionalCommentComponent } from './components/ticket-additional-comment/ticket-additional-comment.component';
import { TicketHistoryComponent } from './components/ticket-history/ticket-history.component';
import { HttpMemberService } from '../../../service/http-member.service';
import { TicketDuplicateWarningModalComponent } from './components/ticket-duplicate-warning-modal/ticket-duplicate-warning-modal.component';
import { NzMessageService } from 'ng-zorro-antd/message';
import { TicketQuestionnaireFormComponent } from './components/ticket-questionnaire-form/ticket-questionnaire-form.component';
import { NzNotificationService } from 'ng-zorro-antd/notification';

@Component({
	selector: 'app-ticket-form',
	standalone: false,
	templateUrl: './ticket-form.component.html',
	styleUrl: './ticket-form.component.scss',
})
export class TicketFormComponent implements OnInit, OnDestroy {
	@ViewChild('ticketHistoryModalTitle', { static: false })
	modalTitleTpl!: TemplateRef<any>;
	ticketHistoryModalRef?: NzModalRef;

	ticketMode!: TicketModeEnum;
	ticket?: TicketDto;
	history?: TicketHistoryDto;
	dynamicForms?: { [key: number]: DynamicFormDto };
	masterForm!: FormGroup;
	allForms: FormGroup[] = [];
	allFormControls: FormControlWrapper[] = [];
	additionalFilesForm!: FormGroup;
	subscription = new Subscription();
	selectedStepIndex = 0;
	categories!: string;
	additionalComment = '';
	visibleButtons: TicketButtonDto[] = [];

	visibleLeftButtons: TicketButtonDto[] = [];
	visibleRightButtons: TicketButtonDto[] = [];

	constructor(
		private fb: FormBuilder,
		private ticketService: HttpTicketService,
		private activatedRoute: ActivatedRoute,
		private router: Router,
		private modalService: NzModalService,
		private drawerService: NzDrawerService,
	) {}

	ngOnInit() {
		this.subscription.add(
			this.activatedRoute.paramMap.subscribe((params) => {
				this.ticketMode = params.get('ticketMode')! as TicketModeEnum;
				const ticketId = params.get('ticketId');
				const workflowId = params.get('workflowId');
				const memberId = params.get('memberId');
				const dependentId = params.get('dependentId');
				const policyId = params.get('policyId');
				this.categories =
					params.get('categories') == null
						? ''
						: params.get('categories')!;

				if (ticketId) {
					this.masterForm = this.fb.group({
						operationalNote: [],
						assignToAgent: [],
					});
				} else {
					this.masterForm = this.fb.group({
						operationalNote: [],
						assignToAgent: ['', Validators.required],
					});
				}
				try {
					if (ticketId) {
						this.ticketService
							.get(+ticketId)
							.subscribe((result) => this.setTicket(result));
					} else if (memberId) {
						this.ticketService
							.newTicketForMainMember(+workflowId!, +memberId!)
							.subscribe((result) => this.setTicket(result));
					} else if (policyId) {
						this.ticketService
							.newTicketForPolicy(+policyId!)
							.subscribe((result) => this.setTicket(result));
					} else {
						this.ticketService
							.newTicketForDependant(+workflowId!, +dependentId!)
							.subscribe((result) => this.setTicket(result));
					}
				} catch (e) {
					alert(e);
				}
			}),
		);
	}
	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
	setTicket(input: TicketDto) {
		this.ticket = input;
		this.history = undefined;
		const activeStep = this.ticket.steps.filter(
			(item) => item.isCurrentState,
		)[0];
		console.log('TICKET RUNTIME DEBUG', {
			ticketId: input.id,
			workflowId: input.workflowId,
			workflowLabel: input.workflowLabel,
			activeStepId: activeStep?.id,
			activeStepLabel: activeStep?.label,
			activeStateLabel: activeStep?.stateLabel,
			activeStepButtons: activeStep?.buttons?.map((button) => ({
				id: button.id,
				label: button.label,
				order: button.order,
				style: button.style,
				type: button.type,
				requiredValidForm: button.requiredValidForm,
			})),
			allSteps: input.steps.map((step) => ({
				stepId: step.id,
				stepLabel: step.label,
				isCurrentState: step.isCurrentState,
				stateLabel: step.stateLabel,
				buttons: step.buttons?.map((button) => ({
					id: button.id,
					label: button.label,
				})),
			})),
		});
		this.selectedStepIndex = this.ticket.steps.indexOf(activeStep);
		this.rebuildVisibleButtons();
		this.dynamicForms = {};
		this.additionalComment = '';

		if (input.id) {
			this.masterForm = this.fb.group({
				operationalNote: [],
				assignToAgent: [],
			});
		} else {
			this.masterForm = this.fb.group({
				operationalNote: [],
				assignToAgent: ['', Validators.required],
			});
		}
		this.allForms = [];
		this.allFormControls = [];

		input.steps = input.steps.sort((i1, i2) => i1.order - i2.order);
		input.steps.forEach((step) => {
			step.sections = step.sections.sort((i1, i2) => i1.order - i2.order);
			step.sections.forEach((section) => {
				section.elements = section.elements.sort(
					(i1, i2) => i1.order - i2.order,
				);
			});
		});

		input.steps.forEach((step) => {
			step.sections = step.sections.sort((i1, i2) => i1.order - i2.order);

			step.sections.forEach((section) => {
				this.dynamicForms![section.id] =
					this.convertToDynamicForm(section);
			});
		});
		this.additionalFilesForm = this.fb.group([]);
		activeStep.additionalFiles.forEach((item) =>
			this.additionalFilesForm.addControl(
				item.label,
				new FormControl(item.uuid, [Validators.required]),
			),
		);

		this.ticketService
			.getTicketHistory(this.ticket.id)
			.subscribe((history) => {
				this.history = history;
			});
	}
	onStepIndexChange(index: number): void {
		this.selectedStepIndex = index;
		this.rebuildVisibleButtons();
	}
	get step(): TicketStepDto {
		return this.ticket!.steps[this.selectedStepIndex]!;
	}

	getStepStatus(
		input: TicketStepDto,
	): 'process' | 'wait' | 'finish' | 'error' {
		if (input.isCurrentState) {
			return 'process';
		}
		let currentStep = this.ticket!.steps.filter(
			(item) => item.isCurrentState,
		)[0];
		if (!currentStep) {
			return 'wait';
		}
		if (input.completed) {
			return 'finish';
		}
		return input.order > currentStep.order ? 'wait' : 'finish';
		// if (input.isCurrentState) {
		// 	return 'process';
		// }
		// const current = this.ticket!.steps.filter(item => item.isCurrentState == true)[0];
		// if (input.order >= current.order) {
		// 	return 'wait';
		// }
		// if (input.completed) {
		// 	return 'finish';
		// }
		// return 'wait';
	}
	getDetailGroups(
		input: TicketStepDto,
	): { groupLabel: string; details: TicketDetailDto[] }[] {
		const groups: { [key: string]: TicketDetailDto[] } = {};
		for (const detail of input.details) {
			const label = detail.groupLabel || 'Ungrouped';
			if (!groups[label]) {
				groups[label] = [];
			}
			groups[label].push(detail);
		}
		return Object.entries(groups).map(([groupLabel, details]) => ({
			groupLabel,
			details,
		}));
	}
	setButtonBusy(button: TicketButtonDto, busy: boolean) {
		(button as any)['busy'] = busy;
	}
	isButtonBusy(button: TicketButtonDto): boolean {
		return (button as any)['busy'] ?? false;
	}

	doReadOnlySave() {
		const ticket = this.copyToTicket();
		const payload = this.getPostBody(ticket, undefined);
		this.ticketService
			.submitWhileReadOnly(ticket, payload)
			.subscribe((result) => {
				this.modalService.success({
					nzTitle: 'Successful',
					nzContent:
						this.ticket!.workflowLabel +
						' ' +
						this.ticketMode +
						' saved',
				});
				this.router.navigate([
					'/ticket',
					this.ticketMode,
					ticket.workflowId,
					this.step.id,
					'list',
				]);
			});
	}
	buttonClick(button: TicketButtonDto) {
		const ticket = this.copyToTicket();
		const payload = this.getPostBody(ticket, button);

		if (!ticket.id) {
			//TODO:  OR button action verify unique == true
			this.ticketService
				.findDuplicateTickets(button, ticket, payload, this.categories)
				.subscribe((result) => {
					if (result.length == 0) {
						this.buttonClickStep2(button, ticket, payload);
					} else {
						const modal = this.modalService.create({
							nzTitle:
								'Duplicate ' + ticket.ticketMode! + ' Detected',
							nzContent: TicketDuplicateWarningModalComponent,
							nzClosable: true,
							nzMaskClosable: false,
							nzWidth: 800,
							nzFooter: null,
						});
						modal.componentInstance!.tickets = result;
						modal.afterClose.subscribe((result) => {
							if (result == true) {
								this.buttonClickStep2(button, ticket, payload);
							}
						});
					}
				});
		} else {
			this.buttonClickStep2(button, ticket, payload);
		}
	}
	getButtonGroups(
		step: TicketStepDto,
	): { statusLabel: string; buttons: TicketButtonDto[] }[] {
		const groups: { [key: string]: TicketButtonDto[] } = {};

		(step.buttons ?? []).forEach((button: TicketButtonDto) => {
			const statusLabel =
				button.statusLabel ?? step.stateLabel ?? 'Actions';

			if (!groups[statusLabel]) {
				groups[statusLabel] = [];
			}

			groups[statusLabel].push(button);
		});

		return Object.keys(groups).map((statusLabel) => ({
			statusLabel,
			buttons: groups[statusLabel].sort((a, b) => a.order - b.order),
		}));
	}
	private buttonClickStep2(
		button: TicketButtonDto,
		ticket: TicketDto,
		payload: TicketUploadPayload,
	) {
		if (button.onClickCaptureAdditionalComment) {
			const modal = this.modalService.create({
				nzTitle: 'Additional Comment',
				nzContent: TicketAdditionalCommentComponent,
				nzFooter: null,
			});
			modal.componentInstance!.button = button;
			modal.componentInstance!.payload = payload;
			modal.afterClose.subscribe((result) => {
				if (result == true) {
					this.additionalComment = payload.additionalComment ?? '';
					this.buttonClickConfirmed(button, ticket, payload);
				}
			});
		} else {
			this.buttonClickConfirmed(button, ticket, payload);
		}
	}

	private rebuildVisibleButtons(): void {
		const step = this.ticket?.steps?.[this.selectedStepIndex];

		if (!step) {
			this.visibleLeftButtons = [];
			this.visibleRightButtons = [];
			return;
		}

		const buttons = [...(step.buttons ?? [])].sort((a, b) => {
			const statusCompare = (a.statusId ?? 0) - (b.statusId ?? 0);

			if (statusCompare !== 0) {
				return statusCompare;
			}

			return a.order - b.order;
		});

		this.visibleLeftButtons = buttons.filter(
			(button) => button.alignment !== 'Right',
		);

		this.visibleRightButtons = buttons.filter(
			(button) => button.alignment === 'Right',
		);

		console.log('VISIBLE BUTTONS', {
			left: this.visibleLeftButtons.map((button) => ({
				id: button.id,
				label: button.label,
				statusId: button.statusId,
				statusLabel: button.statusLabel,
				alignment: button.alignment,
				icon: button.icon,
			})),
			right: this.visibleRightButtons.map((button) => ({
				id: button.id,
				label: button.label,
				statusId: button.statusId,
				statusLabel: button.statusLabel,
				alignment: button.alignment,
				icon: button.icon,
			})),
		});
	}
	private buttonClickConfirmed(
		button: TicketButtonDto,
		ticket: TicketDto,
		payload: TicketUploadPayload,
	) {
		const workflowId = this.ticket!.workflowId;
		const stepId = this.step.id;
		if (
			button.requiredCommunications.length == 0 &&
			button.onClickComposeAdditionalCommunication == false
		) {
			if (
				button.onClickSubmitForm == true ||
				(payload.additionalComment &&
					payload.additionalComment.trim().length > 0)
			) {
				this.ticketService
					.submit(button, ticket, payload, this.categories!)
					.subscribe({
						next: (result) => {
							const currentStep = this.ticket!.steps.filter(
								(item) => item.isCurrentState == true,
							)[0];
							const resultStep = result.steps.filter(
								(item) => item.isCurrentState == true,
							)[0];

							if (
								!resultStep ||
								currentStep.id != resultStep.id ||
								currentStep.stateLabel != resultStep.stateLabel
							) {
								this.setTicket(result);
							}
							this.modalService.success({
								nzTitle: 'Successful',
								nzContent:
									this.ticket!.workflowLabel +
									' ' +
									this.ticketMode +
									' ' +
									(ticket.id ? ' processed' : ' created'),
							});
							this.router.navigate([
								'/ticket',
								this.ticketMode,
								workflowId,
								stepId,
								'list',
							]);
						},
						error: (err) => {
							//{"error":"Internal Server Error","message":"Bank Account Number is required"}
							this.modalService.error({
								nzTitle: 'Failed to process action',
								nzContent:
									err?.error?.message ||
									'An unexpected error occurred',
							});
						},
					});
				return;
			}
			this.router.navigate([
				'/ticket',
				this.ticketMode,
				workflowId,
				stepId,
				'list',
			]);
			return;
		}
		const additionalFiles: { [key: string]: string } = {};
		Object.keys(this.additionalFilesForm.controls).forEach((key) => {
			additionalFiles[key] = this.additionalFilesForm.get(key)?.value;
		});
		console.log('Additional Files', additionalFiles);

		const modal = this.modalService.create({
			nzTitle: 'Compose',
			nzWidth: '80%',
			nzContent: TicketCommunicationModalComponent,
			nzFooter: null,
		});
		modal.componentInstance!.ticketMode = this.ticketMode;
		modal.componentInstance!.step = this.step;
		modal.componentInstance!.button = button;
		modal.componentInstance!.additionalFiles = additionalFiles;

		this.ticketService
			.submitForPlaceholderValues(
				button,
				ticket,
				payload,
				this.categories!,
			)
			.subscribe({
				next: (result) => {
					modal.componentInstance!.placeholderValues = result;
				},
				error: (err) => {
					this.modalService.error({
						nzTitle: 'Error',
						nzContent:
							err?.error?.message ??
							'Failed to load placeholder values.',
					});
				},
			});

		modal.afterClose.subscribe((result) => {
			console.log('Close:', result);
			if (result) {
				payload.additionalCommunications =
					button.additionalCommunications!;
				payload.requiredCommunications = {};
				if (button.requiredCommunications) {
					button.requiredCommunications.forEach((item) => {
						payload.requiredCommunications[item.id] = item;
					});
				}
				this.ticketService
					.submit(button, ticket, payload, this.categories!)
					.subscribe({
						next: (result) => {
							const currentStep = this.ticket!.steps.filter(
								(item) => item.isCurrentState == true,
							)[0];
							const resultStep = result.steps.filter(
								(item) => item.isCurrentState == true,
							)[0];
							const workflowId = ticket.workflowId;
							const stepId = this.step.id;

							// if (!resultStep || currentStep.id != resultStep.id || currentStep.stateLabel != resultStep.stateLabel) {
							// 	this.setTicket(result);
							// }
							this.setTicket(result);

							this.modalService.success({
								nzTitle: 'Successful',
								nzContent:
									this.ticket!.workflowLabel +
									' ' +
									this.ticketMode +
									' ' +
									(ticket.id ? ' processed' : ' created'),
							});
							this.router.navigate([
								'/ticket',
								this.ticketMode,
								workflowId,
								stepId,
								'list',
							]);
						},
						error: (err) => {
							//{"error":"Internal Server Error","message":"Bank Account Number is required"}
							this.modalService.error({
								nzTitle: 'Failed to process action',
								nzContent:
									err?.error?.message ||
									'An unexpected error occurred',
							});
						},
					});
			} else {
				console.log('Modal cancelled');
			}
		});
	}

	private copyToTicket(): TicketDto {
		let out: TicketDto = JSON.parse(JSON.stringify(this.ticket));
		let step = out.steps.filter((item) => item.isCurrentState == true)[0];
		step.sections.forEach((section) => {
			const properties = this.allFormControls.map((item) =>
				item.toBackendPayload(),
			);
			section.elements.forEach((element) => {
				const dfElement = properties.filter(
					(item) => item.propertyId == element.id,
				)[0];
				element.value = (
					dfElement.value as DynamicPayloadDto_PropertyValueSimple
				).value;
			});
		});
		return out;
	}
	private getPostBody(
		input: TicketDto,
		button: TicketButtonDto | undefined,
	): TicketUploadPayload {
		const out: TicketUploadPayload = {
			button: button!,
			additionalFiles: {},
			fieldProperties: {},
			requiredCommunications: {},
			additionalCommunications: [],
			note: this.masterForm.get('operationalNote')!.value,
			assignToAgentId: +this.masterForm.get('assignToAgent')!.value,
			additionalComment: this.additionalComment,
		};
		let step = input.steps.filter((item) => item.isCurrentState == true)[0];
		step.sections
			.map((item) => item.elements)
			.flat()
			.forEach((item) => {
				out.fieldProperties[item.id] = item.value;
			});
		Object.keys(this.additionalFilesForm.controls).forEach((key) => {
			out.additionalFiles[key] = this.additionalFilesForm.get(key)?.value;
		});
		if (button) {
			button.requiredCommunications.forEach((item) => {
				out.requiredCommunications[item.id] = JSON.parse(
					JSON.stringify(item),
				);
			});
			out.additionalCommunications = JSON.parse(
				JSON.stringify(button.additionalCommunications ?? []),
			);
		}

		Object.keys(out.requiredCommunications).forEach((key) => {
			const requiredCommunication = out.requiredCommunications[+key];
			requiredCommunication.attachments =
				requiredCommunication.attachments?.filter(
					(item) => item.selected == true,
				);
		});
		Object.keys(out.additionalCommunications).forEach((key) => {
			const additionalCommunication = out.additionalCommunications[+key];
			additionalCommunication.attachments =
				additionalCommunication.attachments?.filter(
					(item) => item.selected == true,
				);
		});
		return out;
	}

	getNzButtonType(input: TicketButtonDto): NzButtonType {
		if (input.requiredValidForm == false) {
			return input.type.toLowerCase() as NzButtonType;
		}
		if (this.masterForm.valid == true) {
			return input.type.toLowerCase() as NzButtonType;
		}
		return 'default';
	}
	highlightInvalidFields() {
		const ref = this.drawerService.create({
			nzTitle: 'Errors',
			nzContent: InvalidFormDrawerComponent,
			nzWidth: 'large',
			nzContentParams: { form: this.masterForm },
		});
		ref.open();
	}

	private convertToDynamicForm(input: TicketSectionDto): DynamicFormDto {
		const elements: DynamicFormElementDto[] = input.elements.map((item) => {
			return {
				id: item.id,
				value: item.value,
				property: '_' + item.id,
				dependencyId: item.dependencyId,

				name: item.label,
				description: item.description,
				sectionName: input.label,
				dependencyValue: item.dependencyValue,
				dependencyValueInverted: false,
				dataType: item.dataType,
				options: item.options,
				orderIndex: item.order,
				lineNumber: item.lineNumber,
				icon: item.icon,
				activeOnCreate: true,
				activeOnUpdate: true,
				required: item.required,
				hidden: item.hidden,
				errorMessageRequired: item.errorMessageRequired,
				isUnique: item.isUnique,
				errorMessageUnique: item.errorMessageUnique,
				regex: item.regex,
				errorMessageRegex: item.errorMessageRegex,
				minValue: item.minValue,
				errorMessageMinValue: item.errorMessageMinValue,
				maxValue: item.maxValue,
				errorMessageMaxValue: item.errorMessageMaxValue,
				hashCode: 0,
			};
		});

		return {
			id: undefined,
			templateName: 'card',
			elements: elements,
			entityType: 'Member',
			subForms: {},
			hashCode: 0,
		};
	}
	showTicketHistory(ticket: TicketDto, title: string) {
		this.ticketHistoryModalRef = this.modalService.create({
			nzTitle: this.modalTitleTpl,
			nzContent: TicketHistoryComponent,
			nzWidth: '80%',
			nzFooter: null,
		});
		this.ticketHistoryModalRef.componentInstance!.ticket = ticket!;
	}
	openInNewWindow() {
		const url = this.router.serializeUrl(
			this.router.createUrlTree([
				'/ticket',
				this.ticketHistoryModalRef!.componentInstance!.ticket!.id,
				'history',
			]),
		);

		// window.open(url, '_blank', 'width=1280,height=800');

		const newWin = window.open(url, '_blank', 'width=1280,height=800');
		if (!newWin) return;

		// Option A: Navigate to a dedicated route (recommended)
		// newWin.location.href = `/tickets/${this.ticketHistoryModalRef!.componentInstance!.ticket!.id}/history`;
		this.ticketHistoryModalRef?.close();
	}
	trackByDto(index: number, input: AbstractDto): number {
		return (input as any)?.hashCode ?? index;
	}
	trackByGroupLabel(index: number, input: any): string {
		return input.groupLabel;
	}

	getPolicyPersonPrefix() {
		if (this.ticket?.policy?.product?.productType == 'Funeral') {
			return 'Deceased';
		}
		if (
			this.ticket?.policy?.product?.productType == 'TemporaryDisability'
		) {
			return 'Disabled';
		}
		if (
			this.ticket?.policy?.product?.productType == 'PermanentDisability'
		) {
			return 'Disabled';
		}
		if (this.ticket?.policy?.product?.productType == 'CreditLife') {
			return 'Borrower';
		}
		if (this.ticket?.policy?.product?.productType == 'GroupLife') {
			return 'Deceased';
		}
		if (
			this.ticket?.policy?.product?.productType ==
			'PermanentHealthInsurance'
		) {
			return 'Disabled';
		}
		return 'Claim';
	}
	newQuestionnaire() {
		const modal = this.modalService.create({
			nzTitle: 'New Questionnaire',
			nzContent: TicketQuestionnaireFormComponent,
			nzWidth: '80%',
			nzFooter: null,
		});
		modal.componentInstance!.ticket = this.ticket!;
		modal.componentInstance!.questionnaire = undefined!;
	}
	openQuestionnaire(input: TicketQuestionnaireDto) {
		const modal = this.modalService.create({
			nzTitle: 'Questionnaire: ' + input.name,
			nzContent: TicketQuestionnaireFormComponent,
			nzWidth: '80%',
			nzFooter: null,
		});
		modal.componentInstance!.ticket = this.ticket!;
		modal.componentInstance!.questionnaire = input;
	}
	viewQuestionnaires() {
		const modal = this.modalService.create({
			nzTitle: 'View Questionnaire',
			nzContent: TicketQuestionnaireViewComponent,
			nzWidth: '80%',
			nzFooter: null,
		});
		modal.componentInstance!.ticket = this.ticket!;
	}
	canShowCapturedField(field: TicketHistoryCapturedFieldDto): boolean {
		if (!field.inputValue) {
			return false;
		}
		if (field.dataType == 'Text') {
			return true;
		}
		if (field.dataType == 'TextArea') {
			return true;
		}
		if (field.dataType == 'Boolean') {
			return true;
		}
		if (field.dataType == 'DropDownSingle') {
			return true;
		}
		if (field.dataType == 'Number') {
			return true;
		}
		if (field.dataType == 'PastDate') {
			return true;
		}
		if (field.dataType == 'FutureDate') {
			return true;
		}
		if (field.dataType == 'Date') {
			return true;
		}
		if (field.dataType == 'Time') {
			return true;
		}
		if (field.dataType == 'PastDateTime') {
			return true;
		}
		if (field.dataType == 'FutureDateTime') {
			return true;
		}
		// if(field.dataType == 'File') {
		// 	return true;
		// }
		// if(field.dataType == 'Password') {
		// 	return true;
		// }
		if (field.dataType == 'Email') {
			return true;
		}
		if (field.dataType == 'Msisdn') {
			return true;
		}
		// if(field.dataType == 'SetOfRecords') {
		// 	return true;
		// }
		// if(field.dataType == 'SelectFromRecords') {
		// 	return true;
		// }
		if (field.dataType == 'RequiredCheckbox') {
			return true;
		}
		// if(field.dataType == 'Hierarchy') {
		// 	return true;
		// }
		// if(field.dataType == 'DependantList') {
		// 	return true;
		// }
		// if(field.dataType == 'MemberAndDependantList') {
		// 	return true;
		// }
		if (field.dataType == 'CheckboxWithStaticValue') {
			return true;
		}
		if (field.dataType == 'IdNumberOfLivingPerson') {
			return true;
		}
		if (field.dataType == 'IdNumberOfDeceasedPerson') {
			return true;
		}
		if (field.dataType == 'ICD10') {
			return true;
		}
		// if(field.dataType == 'Person') {
		// 	return true;
		// }
		// if(field.dataType == 'BankingDetails') {
		// 	return true;
		// };
		return false;
	}
}
